import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TvPage } from './pages/TvPage';
import { DjPage } from './pages/DjPage';
import './App.css';

/** Корневой роутер приложения. */
function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/tv" element={<TvPage />} />
      <Route path="/dj" element={<DjPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function AppWithRouter() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
